import { Notification } from '../../../../models';
import { NotificationPauseState } from '../../../../state/actions/common';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { publishSingleNotification, saveMultipleNotificationsPauseState } from '../../../../state/actions/notificationsList';
import { useTranslation } from 'react-i18next';

const keyPrefix = 'components.dialogs.publishNotificationConfirm.usePublishNotifications';

export function usePublishNotifications() {
    const { t } = useTranslation('', { keyPrefix });
    const dispatch = useDispatch();

    return useCallback(
        (notifications: Notification[], systemId: string, environmentId: string, isResuming: boolean, isPausing: boolean) => {
            if (notifications.length === 1) {
                return dispatch(publishSingleNotification(notifications[0], environmentId, { isResuming, isPausing }));
            }

            return dispatch(
                saveMultipleNotificationsPauseState(
                    notifications,
                    NotificationPauseState.Resume,
                    environmentId,
                    t('resumedSuccessfully', { count: notifications.length }),
                    t('error')
                )
            );
        },
        [dispatch, t]
    );
}
